import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { DelaisReglementairesRepository } from '../../../../store/delais-reglementaires-state/delais-reglementaires-state.repository';

interface getDelaisReglementairesAddDrawerObjectProps {
  store?: DelaisReglementairesRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getDelaisReglementairesAddDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: getDelaisReglementairesAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.delaisReglementaires.addTitle',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.delaisReglementaires.form.submit',
        onClick: () => action?.(),
      },
      {
        label: 'settings.delaisReglementaires.form.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
